import { render, staticRenderFns } from "./hazardRectificationTab1.vue?vue&type=template&id=1967b5fd&scoped=true"
import script from "./hazardRectificationTab1.vue?vue&type=script&lang=js"
export * from "./hazardRectificationTab1.vue?vue&type=script&lang=js"
import style0 from "./hazardRectificationTab1.vue?vue&type=style&index=0&id=1967b5fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967b5fd",
  null
  
)

export default component.exports